import { render, staticRenderFns } from "./VerClientesProfile.vue?vue&type=template&id=e4846014&"
import script from "./VerClientesProfile.vue?vue&type=script&lang=js&"
export * from "./VerClientesProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports